import { useState, useRef } from "react";
const retroFieldStyle = {
backgroundColor: "#2a2a2a",
color: "#00ff00",
border: "1px solid #00ff00",
padding: "10px",
fontFamily: '"Press Start 2P", cursive',
};


const errorStyle = {
color: "#ff0000",
fontSize: "10px",
};

export const RetroInput = ({ label, error, style = {}, type = "text", ...props }) => (
<>
{type === "number" && label && <label>{label}</label>}

<input
type={type}
{...props}
placeholder={type === "number" ? undefined : props.placeholder || label}
style={{ ...retroFieldStyle, ...style }}
/>


{error && <span style={errorStyle}>{error}</span>}
</>
);


export const RetroTextarea = ({ label, error, style = {}, ...props }) => (
<>


<textarea
{...props}
placeholder={label}
style={{ ...retroFieldStyle, minHeight: 120, ...style }}
/>


{error && <span style={errorStyle}>{error}</span>}
</>
);


export const RetroSelect = ({ label, error, options = [], style = {}, ...props }) => (
<>
{label && <label style={{fontSize :'13px'}}>{label}</label>}


<select {...props} style={{ ...retroFieldStyle, ...style }}>
<option value="">Sélectionnez</option>


{options.map((opt) => (
<option key={opt.value} value={opt.value}>
{opt.label}
</option>
))}
</select>


{error && <span style={errorStyle}>{error}</span>}
</>
);


export const RetroFileInput = ({ label, error, style = {}, ...props }, ref) => (
<>
{label && <label>{label}</label>}


<input 
  type="file" 
  ref={ref}
  {...props} 
  style={{ ...retroFieldStyle, ...style }} />


{error && <span style={errorStyle}>{error}</span>}
</>
);




export const RetroButton = ({ children, style = {}, ...props }) => (
<button
{...props}
style={{
backgroundColor: "#00ff00",
color: "#000",
border: "none",
padding: "12px",
fontFamily: '"Press Start 2P", cursive',
cursor: "pointer",
fontSize: 14,
...style,
}}
>
{children}
</button>
);


export const RetroDeleteButton = ({ onConfirm, style = {}, ...props }) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowConfirm(true);
  };

  const handleConfirm = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    onConfirm();
    setShowConfirm(false);
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    setShowConfirm(false);
  };

  return (
    <>
      <RetroButton
        onClick={handleClick}
        style={{
          backgroundColor: "#ff0000",
          color: "#fff",
          ...style,
        }}
        {...props}
      >
        {showConfirm ? (
          <>
            Êtes-vous sûr ? Cette opération est irréversible.
            <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
              <RetroButton
                onClick={handleConfirm}
                style={{ backgroundColor: "#ff0000", padding: "6px 12px", fontSize: "12px" }}
              >
                Oui
              </RetroButton>
              <RetroButton
                onClick={handleCancel}
                style={{ backgroundColor: "#00ff00", padding: "6px 12px", fontSize: "12px" }}
              >
                Non
              </RetroButton>
            </div>
          </>
        ) : (
          "Supprimer"
        )}
      </RetroButton>
    </>
  );
};



///////// CHECKBOX ////////////

const retroCheckboxContainerStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  margin: "10px 0",
};






const retroCheckboxInputStyle = {
  width: "18px",
  height: "18px",
  backgroundColor: "#2a2a2a",
  border: "2px solid #00ff00",
  outline: "none",
  cursor: "pointer",
  appearance: "none",
  position: "relative",
  WebkitAppearance: "none",
  transition: "all 0.2s ease",
   '&:checked': {
    backgroundColor: "#00ff00",
    borderColor: "#00ff00",
    boxShadow: "0 0 8px #00ff00",
  },
  '&:checked::after': {
    content: '"✓"',
    position: "absolute",
    color: "#000",
    fontSize: "10px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontFamily: '"Press Start 2P", cursive',
  },
};

const retroCheckboxLabelStyle = {
  fontFamily: '"Press Start 2P", cursive',
  color: "#00ff00",
  fontSize: "12px",
   cursor: "pointer",
  userSelect: "none",
};




export const RetroCheckbox = ({ label, error, style = {}, ...props }) => (
  <>
    <div style={retroCheckboxContainerStyle}>
      <input
        type="checkbox"
        {...props}
        style={{
          ...retroCheckboxInputStyle,
          ...style,
          ...(props.checked ? retroCheckboxInputStyle['&:checked'] : {}),
        }}
      />
      {label && <label style={retroCheckboxLabelStyle}>{label}</label>}
    </div>
    {error && <span style={errorStyle}>{error}</span>}
  </>
);





export const RetroSequenceCheck = ({ onSuccess }) => {
  const [sequence, setSequence] = useState(['↑', '↑', '↓', '↓']);
  const [userInput, setUserInput] = useState([]);
  const [message, setMessage] = useState('Pour validez le formulairez répétez la séquence: ↑ ↑ ↓ ↓');

  const handleKeyPress = (key) => {
    const newInput = [...userInput, key];
    setUserInput(newInput);
    if (newInput.join('') === sequence.join('')) {
      setMessage('CORRECT!');
      onSuccess(true);
    } else if (newInput.length === sequence.length) {
      setMessage('FAUX, RÉESSAYEZ.');
      setTimeout(() => {
        setUserInput([]);
        setMessage('Pour validez le formulairez répétez la séquence: ↑ ↑ ↓ ↓');
      }, 1000);
    }
  };

  return (
    <div style={{ textAlign: 'center', margin: '20px 0' }}>
      <p style={{
        fontFamily: '"Press Start 2P", cursive',
        color: '#00ff00',
        fontSize: '12px',
        marginBottom: '10px'
      }}>
        {message}
      </p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
        {['↑', '↓'].map((key) => (
          <button
            key={key}
            type="button"
            onClick={() => handleKeyPress(key)}
            style={{
              backgroundColor: '#2a2a2a',
              color: '#00ff00',
              border: '2px solid #00ff00',
              padding: '10px',
              fontSize: '16px',
              cursor: 'pointer',
              fontFamily: '"Press Start 2P", cursive',
              transition: 'all 0.1s ease',
              transform: 'scale(1)',
              boxShadow: '0 0 5px #00ff00',
              ':active': { 
                transform: 'scale(0.95)',
                boxShadow: '0 0 15px #00ff00, inset 0 0 5px #00ff00',
                outline: 'none',
            },
            }}
            onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.95)';
            e.currentTarget.style.boxShadow = '0 0 15px #00ff00, inset 0 0 5px #00ff00';
            }}
            onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 0 5px #00ff00';
            }}
  >
    {key}
  </button>
        ))}
      </div>
    </div>
  );
};